//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ["currentUser", "otherUser", "messages"],
  methods: {
    scrollToEnd: function scrollToEnd() {
      var _this = this;

      setTimeout(function () {
        var container = _this.$refs.chatArea.$el;
        container.scrollTop = container.scrollHeight;
      }, 0);
    }
  },
  mounted: function mounted() {
    this.scrollToEnd();
  },
  updated: function updated() {
    this.scrollToEnd();
  }
};